import { render, staticRenderFns } from "./ai.vue?vue&type=template&id=b40ca0f6&scoped=true"
import script from "./ai.vue?vue&type=script&lang=js"
export * from "./ai.vue?vue&type=script&lang=js"
import style0 from "./ai.vue?vue&type=style&index=0&id=b40ca0f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b40ca0f6",
  null
  
)

export default component.exports